
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetonashikandlgatpuri() {



    const cardData =
    {
        keyword: 'Pune To Nashik And Igatpuri Cab',
        heading: 'Mauli Cabs: Pune To Nashik And Igatpuri Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Nashik and Igatpuri cab services, ensuring a smooth and scenic journey to two of Maharashtras most popular destinations. Whether you are visiting Nashik for its temples and vineyards or heading to Igatpuri for its picturesque landscapes, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Nashik and Igatpuri.',

        top: 'Top Places to Visit in Nashik with Mauli Cabs',

"topPlaces": [
    {
        "title": "Trimbakeshwar Temple",
        "description": "The Trimbakeshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva. It is a major pilgrimage site, known for its rich history and stunning architecture, located in the sacred town of Trimbak, near Nashik."
    },
    {
        "title": "Kalaram Sansthan Mandir",
        "description": "The Kalaram Sansthan Mandir is an ancient temple dedicated to Lord Rama. It is one of the most significant religious sites in Nashik and attracts thousands of devotees each year."
    },
    {
        "title": "Saptashrungi",
        "description": "Saptashrungi is a sacred hill and an important pilgrimage site, home to the Saptashrungi Devi Temple. It is known for its stunning views and the challenging climb to the temple, offering a blend of spirituality and adventure."
    },
    {
        "title": "Panchavati",
        "description": "Panchavati is a revered area in Nashik, associated with the Hindu epic Ramayana. It is believed to be the place where Lord Rama, along with his wife Sita and brother Lakshmana, spent part of their exile. It is home to several temples, ghats, and holy spots."
    },
    {
        "title": "Godavari River",
        "description": "The Godavari River, one of the longest rivers in India, flows through Nashik. It is an important religious site, and many temples and ghats are located along its banks. The Godavari is considered sacred, and pilgrims often take a holy dip in its waters."
    },
    {
        "title": "Pandav Leni",
        "description": "Pandav Leni is a group of ancient Buddhist rock-cut caves located near Nashik. The caves feature intricate carvings and inscriptions, providing a glimpse into the region's Buddhist heritage."
    },
    {
        "title": "Anjneri Hill",
        "description": "Anjneri Hill, located near Nashik, is believed to be the birthplace of Lord Hanuman. The hill offers beautiful trekking routes, making it a popular spot for adventure enthusiasts and pilgrims alike."
    },
    {
        "title": "Nashik Vineyards",
        "description": "Nashik is known as the 'Wine Capital of India.' The region is home to several vineyards and wineries, offering wine-tasting tours and a chance to experience Nashik's thriving wine culture."
    },
    {
        "title": "Sula Vineyard",
        "description": "Sula Vineyard is one of the most famous wineries in Nashik. It offers wine tours, tastings, and a beautiful view of the vineyards, making it a popular spot for wine lovers."
    },
    {
        "title": "Muktidham Temple",
        "description": "Muktidham Temple is a sacred site in Nashik dedicated to various Hindu deities. The temple complex is known for its replicas of 12 Jyotirlingas and the unique spiritual experience it offers to visitors."
    }
],

"services": [
    {
        "name": "Pune to Nashik and Igatpuri Cab Service",
        "description": "Mauli Cabs offers convenient and comfortable cab services from Pune to Nashik and Igatpuri. Enjoy a smooth ride to these popular destinations for a peaceful and enjoyable trip."
    },
    {
        "name": "Book Pune to Nashik and Igatpuri Taxi",
        "description": "Book your taxi from Pune to Nashik and Igatpuri with Mauli Cabs. We offer easy and hassle-free booking for a comfortable and safe journey to both of these beautiful destinations."
    },
    {
        "name": "Affordable Pune to Nashik and Igatpuri Cab",
        "description": "Mauli Cabs offers affordable taxi services from Pune to Nashik and Igatpuri. Enjoy a cost-effective and enjoyable journey to these picturesque locations with reliable services."
    },
    {
        "name": "Private Taxi from Pune to Nashik and Igatpuri",
        "description": "Travel privately to Nashik and Igatpuri from Pune with Mauli Cabs. We offer personalized services to ensure you have a peaceful and comfortable trip to these amazing places."
    },
    {
        "name": "Nashik and Igatpuri Trip by Cab from Pune",
        "description": "Mauli Cabs provides taxi services for your Nashik and Igatpuri trip from Pune. Whether you're visiting temples or enjoying the scenic views, we ensure a comfortable and safe ride."
    },
    {
        "name": "Pune to Nashik and Igatpuri One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip taxi services from Pune to Nashik and Igatpuri, offering flexibility and convenience for your travel plans."
    },
    {
        "name": "Comfortable Taxi Ride to Nashik and Igatpuri",
        "description": "Enjoy a comfortable and smooth taxi ride from Pune to Nashik and Igatpuri with Mauli Cabs. Our well-maintained vehicles ensure a relaxed and pleasant journey to both destinations."
    },
    {
        "name": "Group Travel to Nashik and Igatpuri",
        "description": "Mauli Cabs offers spacious vehicles for group travel to Nashik and Igatpuri from Pune. Whether you're traveling with family or friends, we ensure a comfortable and enjoyable ride."
    },
    {
        "name": "Luxury Taxi for Nashik and Igatpuri",
        "description": "Travel in luxury to Nashik and Igatpuri from Pune with Mauli Cabs' premium taxi services. Experience top-class comfort and style during your journey to these beautiful destinations."
    },
    {
        "name": "Nashik and Igatpuri Sightseeing by Taxi",
        "description": "Mauli Cabs provides sightseeing taxi services for Nashik and Igatpuri. Explore the best attractions and temples of these destinations in comfort with our professional drivers."
    }
],

"tableData": [
    ["Pune to Nashik and Igatpuri Cab Service", "Book Pune to Nashik and Igatpuri Taxi"],
    ["Affordable Pune to Nashik and Igatpuri Cab", "Private Taxi from Pune to Nashik and Igatpuri"],
    ["Nashik and Igatpuri Trip by Cab from Pune", "Pune to Nashik and Igatpuri One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Nashik and Igatpuri", "Group Travel to Nashik and Igatpuri"],
    ["Luxury Taxi for Nashik and Igatpuri", "Nashik and Igatpuri Sightseeing by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Nashik and Igatpuri trip. Our professional drivers ensure timely pickups and drop-offs, helping you explore both cities without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Nashik and Igatpuri journey, we offer a range of comfortable vehicles, including sedans, SUVs, and premium cars. All vehicles are air-conditioned, spacious, and well-maintained, ensuring a smooth and comfortable ride throughout the trip."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are well-versed with the best routes to Nashik and Igatpuri. They ensure a safe, smooth, and hassle-free journey, keeping you informed about local attractions and the best spots along the way."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your Pune to Nashik and Igatpuri trip. There are no hidden charges, and we ensure that you get the best value for your money with clear, upfront pricing."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers strictly follow safety protocols to ensure your journey is secure and comfortable."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Nashik and Igatpuri trip. Whether you're planning an early morning departure or a late-night return, our customer service team is ready to assist you with your booking anytime."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Nashik and Igatpuri cab with Mauli Cabs is simple and hassle-free. You can book online through our website or mobile app, or contact our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Nashik and Igatpuri trip. Whether you're visiting for sightseeing, a religious tour, or a weekend getaway, we can tailor your journey to meet your preferences and needs."
    }
]

















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Nashik and Igatpuri with Mauli Cabs?',
            answer: 'Booking your cab to Nashik and Igatpuri is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location, Nashik or Igatpuri as your destination, and select the vehicle that suits your needs. Alternatively, you can call our support team for assistance with your booking.',
        },
        {
            question: 'What types of cabs are available for the Pune to Nashik and Igatpuri trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose the vehicle that best suits your group size, comfort level, and budget for the journey.',
        },
        {
            question: 'Is the fare for the Pune to Nashik and Igatpuri trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. You will receive the total fare upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Nashik and Igatpuri take?',
            answer: 'The journey from Pune to Nashik typically takes around 4 to 5 hours, while a trip to Igatpuri takes approximately 5 to 6 hours, depending on traffic conditions. Our drivers ensure a smooth and comfortable ride throughout the journey.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Nashik and Igatpuri route?',
            answer: 'Yes, Mauli Cabs drivers are well-experienced and familiar with the routes to Nashik and Igatpuri. They ensure safe and efficient travel, taking you on the best routes to ensure you reach your destination comfortably.',
        },
        {
            question: 'Can I book a round trip from Pune to Nashik and Igatpuri?',
            answer: 'Yes, you can book a round trip for Nashik and Igatpuri. Simply provide your return details when booking, and we will ensure a smooth trip back to Pune after your visit to these destinations.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Nashik or Igatpuri?',
            answer: 'Yes, you can make stops for sightseeing at various attractions on the way. Whether you want to visit Trimbakeshwar Temple in Nashik or explore the scenic spots in Igatpuri, our drivers can accommodate your preferences.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and maintained for cleanliness and comfort. We ensure a pleasant and comfortable ride for your journey to Nashik and Igatpuri.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy via our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Nashik and Igatpuri trip?',
            answer: 'Mauli Cabs offers competitive pricing, a wide range of vehicle options, professional drivers, and timely service. We ensure that your trip to Nashik and Igatpuri is comfortable, safe, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Vijay Rathi",
            position: "Traveler",
            text: "Our trip to Nashik and Igatpuri with Mauli Cabs was a great experience! The driver was knowledgeable and took us to all the key attractions in both places. The car was very comfortable and clean. I highly recommend Mauli Cabs for anyone visiting these places!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Nisha Shetty",
            position: "Nature Lover",
            text: "Mauli Cabs made our trip to Nashik and Igatpuri a memorable one. The drive was smooth and enjoyable, and we got to see the beautiful spots along the way. The driver was friendly and professional, and the vehicle was in excellent condition. Would definitely use their service again!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Nashik and Igatpuri Cab by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Nashik and Igatpuri. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to these beautiful destinations with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "5600"
        }
      };
      
     
      

    return (
        <div>
            <GTag/>
 <Helmet>
        <title>Pune to Nashik and Igatpuri Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Nashik and Igatpuri cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Nashik and Igatpuri cab service, Book Pune to Nashik and Igatpuri taxi, Affordable Pune to Nashik and Igatpuri cab, Private taxi from Pune to Nashik and Igatpuri, Nashik and Igatpuri trip by cab from Pune, Pune to Nashik and Igatpuri one-way or round trip, Comfortable taxi ride to Nashik and Igatpuri, Group travel to Nashik and Igatpuri, Luxury taxi for Nashik and Igatpuri, Nashik and Igatpuri sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonashikandlgatpuri;